import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Navigate  } from 'react-router-dom';



export default class Logout extends Component {
	 constructor(props) {
    super(props);
	 this.state = {redirect:false,pagename:''}
	 }
	componentDidMount() {
		var strusername="",strpawd="";

		if(localStorage.getItem("GBUsername")!==null)
		{
			strusername=localStorage.getItem("GBUsername");
			strpawd=localStorage.getItem("GBpwd");
		}
		localStorage.clear();
		localStorage.setItem("GBUsername",strusername);
		localStorage.setItem("GBpwd",strpawd);
	
		
		this.setState({
							redirect: true,
							pagename:'/Businesslogin'
						  }) 
	}
	render() {
		if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return (
<React.Fragment>
</React.Fragment>
)
	}
}



